<template>
  <section>
    <div id="was-became" class="pd70">
      <div class="wrapper w1000">
        <UiAnim tag="h2" class="block_title">{{ title }}</UiAnim>

        <UiAnim id="before-after-conteiner" class="user_selet_none">
          <div class="content">
            <div id="before-after" ref="target">
              <img :src="before" :alt="_b" />
              <img :src="after" :alt="_a" />
            </div>
            <div class="ba-overlay">
              <div class="ba-before-label ba-label">{{ _b }}</div>
              <div class="ba-after-label ba-label">{{ _a }}</div>
            </div>
          </div>
        </UiAnim>
      </div>
    </div>
  </section>
</template>

<script setup>
import { loadJs } from "~/helpers/file";
const props = defineProps(["before", "after", "title"]);
import { useElementVisibility } from "@vueuse/core";
import { useTemplateRef } from "vue";
const target = useTemplateRef("target");
const isVisible = useElementVisibility(target);
const _b = "Было";
const _a = "Стало";
const loaded = ref(false);

watch(isVisible, async (v) => {
  if (v && !loaded.value) {
    loaded.value = await loadJs("/static/libs/cocoen.js", "cocoenJS");
    Cocoen.create(target.value);
  }
});
</script>
